import { onMounted, onUnmounted } from 'vue'

import { useDataLayer } from '@toni/brand-ui'

export function useSponsoredLinkTracking () {
  onMounted(() => {
    document.querySelectorAll('.blockText a').forEach(anchor => {
      anchor.addEventListener('click', sponsoredLinkClickHandler)
    })
  })

  onUnmounted(() => {
    document.querySelectorAll('.blockText a').forEach(anchor => {
      anchor.removeEventListener('click', sponsoredLinkClickHandler)
    })
  })
}

const sponsoredLinkClickHandler = (event: { target: any }) => {
  const target = event.target

  if (target && target.hasAttribute('rel') && target.getAttribute('rel').includes('sponsored')) {
    const dataLayer = useDataLayer()

    const sponsoredLinkTrackingData = {
      event: 'product_text_link_click',
      product_url: target.href
    }

    dataLayer.push(sponsoredLinkTrackingData)
  }
}
